<script lang="ts">
	import { page } from '$app/state';
	import { removeCookie, setCookie } from '$services/CookieService';
	import { onMount } from 'svelte';
	import type { TestUser } from '../../domain/TestUser';

	export let testUsers: TestUser[];

	const defaultCustomerId = 'basicCustomerId';

	let selectedUser: string;
	let app: string;

	const appValues = [{ displayName: "desktop", value: "" }, { displayName: "app", value: "app" }];

	onMount(() => {
		selectedUser = localStorage.getItem('testUserType') || defaultCustomerId;
		app = localStorage.getItem('isApp') || appValues[0].value;
	});

	const onTestingUserChange = ( event: any) => {
		selectedUser = event.currentTarget.value;
		const owt = testUsers.find(testUser => testUser.customerId === selectedUser)!.owt;
		setCookie('owt', owt);
		localStorage.setItem('testUserType', selectedUser);
		window.location.reload();
	};
	const onAppCookieChange = ( event: any) => {
		app = event.currentTarget.value;
		if(app != "") {
			setCookie('app', 'true');
		} else {
			removeCookie('app');
		}
		localStorage.setItem('isApp', app);
		window.location.reload();
	};

	const pageName = (() => {
		switch (page.route.id?.replace('/', '')) {
			case 'Home':
				return 'Mein UP';
			default:
				return 'Mitgliedschaft';
		}
	})();
</script>
<div class="oc-pt-100 oc-pl-100">
	<oc-dropdown-v1 aria-label="test-users" class="oc-ml-100" onchange={onTestingUserChange} value="{selectedUser}" label="Testing User" >
		{#each testUsers as testUser}
			<option value={testUser.customerId}>{testUser.displayName}</option>
		{/each}
	</oc-dropdown-v1>
</div>


<div class="oc-pt-100 oc-pl-100">
	<oc-dropdown-v1 aria-label="app-value" class="oc-ml-100" onchange={onAppCookieChange} value="{app}" label="App or desktop" >
		{#each appValues as appValue}
			<option value={appValue.value}>{appValue.displayName}</option>
		{/each}
	</oc-dropdown-v1>
</div>
<div class="oc-pt-150 oc-pl-100" style="background-color: #FFFFFF">
	<span class="oc-headline-300">{pageName}</span> <span> (Simulated FT4 headline area)</span>
</div>
